import { regularFont } from "@app/styles";
import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0px;
  bottom: 0;
  z-index: 10;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 90px;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
`;
export const LoaderText = styled.p`
  margin-top: 10px;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0.1em;
  ${regularFont};
`;
